import { Inject, Injectable } from '@angular/core';
import { API_URL } from '../../app-store-providers';
import { HttpClient } from '@angular/common/http';
import { EntityTypes } from '../../entity/entity-types';
import { DictionaryOperation } from './models/operation';
import { DictionaryOperationPayload } from './models/operation-payload';
import { StoreBaseService } from '../../common/base.service';

@Injectable({
  providedIn: 'root'
})
export class DictionaryOperationService
  extends StoreBaseService<DictionaryOperation, DictionaryOperationPayload> {

  get entityType(): string {
    return EntityTypes.operation;
  }

  get resourceName(): string {
    return 'operation';
  }

  constructor(
    @Inject(API_URL) apiUrl: string,
    http: HttpClient
  ) {
    super(apiUrl, http);
  }
}
